import { render } from "./_edit.vue?vue&type=template&id=0d90670b&scoped=true"
import script from "./_edit.vue?vue&type=script&lang=js"
export * from "./_edit.vue?vue&type=script&lang=js"

import "./_edit.vue?vue&type=style&index=0&id=0d90670b&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d90670b"]])

export default __exports__